module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp12_0.430e3bc0.png";